import { POST_ORDER_ACCEPTED, POST_ORDER_ACCEPTED_SUCCESS, POST_ORDER_ACCEPTED_ERROR, RESET_POST_ORDER, CANCEL_POST_ORDER, CANCEL_POST_ORDER_ERROR, CANCEL_POST_ORDER_SUCCESS, CHECK_IN_REQUEST, CHECK_IN_REQUEST_ERROR, CHECK_IN_REQUEST_SUCCESS, FETCH_CASH_TRANSCATION_ID, FETCH_CASH_TRANSCATION_ID_FAILURE, FETCH_CASH_TRANSCATION_ID_SUCCESS, ADD_HOPE_PAY_ACCEPTED, ADD_HOPE_PAY_ACCEPTED_FAILURE, ADD_HOPE_PAY_ACCEPTED_SUCCESS, GIFT_CARD_PURCHASE, GIFT_CARD_PURCHASE_SUCCESS, GIFT_CARD_PURCHASE_ERROR } from '../../constants';
const initialState = {
    orderAcceptedLoading: false,
    orderAccepted: {},
    postOrderError: false,
    cancelPostOrder: {},
    cancelOrderLoading: false,
    checkInRequest: {},
    checkInRequestLoading: false,
    cashTranscationResponse: {},
    addHopeOrderLoading: false,
    addHopeOrderResponse: {},
    addHopeOrderError: false,
    giftCardPurchaseLoading: false,
    giftCardPurchaseResponse: {},
    giftCardPurchaseError: false
};
const postOrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case POST_ORDER_ACCEPTED:
            return {
                ...state,
                orderAcceptedLoading: true,
                orderAccepted: {},
                postOrderError: false,
            };
        case POST_ORDER_ACCEPTED_SUCCESS:
            return {
                ...state,
                orderAcceptedLoading: false,
                postOrderError: false,
                orderAccepted: action.response,
            };
        case POST_ORDER_ACCEPTED_ERROR:
            return {
                ...state,
                orderAcceptedLoading: false,
                postOrderError: true,
            };
        case RESET_POST_ORDER:
            return {
                ...state,
                orderAcceptedLoading: false,
                orderAccepted: {},
                postOrderError: false,
                cancelPostOrder: {},
                addHopeOrderResponse: {},
                addHopeOrderLoading: false,
                giftCardPurchaseLoading: false,
                giftCardPurchaseResponse: {}
            };
        case FETCH_CASH_TRANSCATION_ID:
        case FETCH_CASH_TRANSCATION_ID_FAILURE: {
            return {
                ...state,
                cashTranscationResponse: {},
            };
        }
        case FETCH_CASH_TRANSCATION_ID_SUCCESS: {
            return {
                ...state,
                cashTranscationResponse: action.response,
            };
        }
        case CANCEL_POST_ORDER:
            return {
                ...state,
                cancelOrderLoading: true,
                cancelPostOrder: {},
            };
        case CANCEL_POST_ORDER_SUCCESS:
            return {
                ...state,
                cancelOrderLoading: false,
                cancelPostOrder: action.response,
            };
        case CANCEL_POST_ORDER_ERROR:
            return {
                ...state,
                cancelOrderLoading: false,
            };
        case CHECK_IN_REQUEST:
            return {
                ...state,
                checkInRequestLoading: true,
                checkInRequest: {},
            };
        case CHECK_IN_REQUEST_SUCCESS:
            return {
                ...state,
                checkInRequestLoading: false,
                checkInRequest: action.response,
                orderAccepted: action.response.order,
            };
        case CHECK_IN_REQUEST_ERROR:
            return {
                ...state,
                checkInRequestLoading: false,
            };
        case ADD_HOPE_PAY_ACCEPTED:
            return {
                ...state,
                addHopeOrderLoading: true,
                addHopeOrderResponse: {},
                addHopeOrderError: false,
            };
        case ADD_HOPE_PAY_ACCEPTED_SUCCESS:
            return {
                ...state,
                addHopeOrderLoading: false,
                addHopeOrderResponse: action.response,
                addHopeOrderError: false
            };
        case ADD_HOPE_PAY_ACCEPTED_FAILURE:
            return {
                ...state,
                addHopeOrderLoading: false,
                addHopeOrderError: true
            };
        case GIFT_CARD_PURCHASE:
            return {
                ...state,
                giftCardPurchaseLoading: true,
                giftCardPurchaseResponse: {},
                giftCardPurchaseError: false,
            };
        case GIFT_CARD_PURCHASE_SUCCESS:
            return {
                ...state,
                giftCardPurchaseLoading: false,
                giftCardPurchaseResponse: action.response,
                giftCardPurchaseError: false
            };
        case GIFT_CARD_PURCHASE_ERROR:
            return {
                ...state,
                giftCardPurchaseLoading: false,
                giftCardPurchaseError: true
            };
        default:
            // need this for default case
            return state;
    }
};
export default postOrderReducer;
